import roomTemplates from "./C1_roomTemplates";
import { RoomType } from "../types/C1_ModelTypes";

/** Recognizes catalog labels and common names of rooms imported from the main app. */
export function roomTypeFromName(name: string): RoomType {
  const normalize = (value: string) => value.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().replace(/ß/g, "ss").trim();
  const normalized = normalize(name);
  const exact = roomTemplates.find(template => Object.values(template.description).some(label => label && normalize(label) === normalized));
  if (exact) return exact.type;
  const aliases: Array<[RegExp, RoomType]> = [
    [/gast.*(wc|bad|toilet)|guest.*(toilet|bath)|gastewc|\bwc\b|toilette/, RoomType.GuestToilet],
    [/kinder|kind |child|kids|nursery/, RoomType.Child],
    [/schlaf|eltern|gastezimmer|\bgaste\b|bedroom|guest room|parents/, RoomType.Bedroom],
    [/kuche|kitchen/, RoomType.Kitchen],
    [/wohn|living|lounge/, RoomType.Living],
    [/esszimmer|essbereich|essen|dining/, RoomType.Dining],
    [/bade|bad\b|bath|dusche/, RoomType.Bathroom],
    [/arbeit|buro|office|study/, RoomType.Office],
    [/flur|diele|korridor|hallway|corridor/, RoomType.Hallway],
    [/treppe|stair/, RoomType.Staircase],
    [/heiz|boiler/, RoomType.HeatingRoom],
    [/hausanschluss|utility connection/, RoomType.UtilityConnectionRoom],
    [/hauswirtschaft|utility|hwr/, RoomType.Utility],
    [/wasch|laundry/, RoomType.Laundry],
    [/abstell|vorrat|storage|pantry/, RoomType.Storage],
    [/garage/, RoomType.Garage],
    [/terrass|terrace|patio/, RoomType.Terrace],
    [/balkon|balcony/, RoomType.Balcony],
    [/garten|garden/, RoomType.Garden],
    [/hobby/, RoomType.Hobby],
  ];
  return aliases.find(([pattern]) => pattern.test(normalized))?.[1] ?? RoomType.Other;
}
